(function(){
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main=g.querySelector('[data-main]'), view=g.querySelector('[data-view]');
    g.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        main.src=t.dataset.src; main.srcset=t.dataset.srcset||''; main.alt=t.dataset.alt||'';
        if(view) view.textContent=t.dataset.view||'';
        g.querySelectorAll('[data-thumb]').forEach(function(x){x.setAttribute('aria-current', x===t?'true':'false')});
      });
    });
  });
  document.querySelectorAll('[data-qty]').forEach(function(q){
    var i=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=Math.max(parseInt(i.min||'0',10), (parseInt(i.value,10)||0)+parseInt(b.dataset.step,10));
        i.value=v; i.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  });
  var form=document.querySelector('[data-atc]');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var buyNow=e.submitter&&e.submitter.hasAttribute('data-buy-now');
      var btn=e.submitter||form.querySelector('[type=submit]'), note=form.querySelector('[data-note]');
      btn.disabled=true; note.textContent='Adding…';
      fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/add.js':'/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){return r.json().then(function(j){if(!r.ok) throw j; return j;})})
        .then(function(){ if(buyNow){ window.location.href='/checkout'; throw {silent:true}; } return fetch('/cart.js').then(function(r){return r.json()})})
        .then(function(c){
          document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count});
          note.innerHTML='Added to cart. <a href="/cart">View cart</a>';
        })
        .catch(function(err){ if(err&&err.silent) return; note.textContent=(err&&err.description)||'Could not add this item. Please try again.';})
        .finally(function(){btn.disabled=false;});
    });
  }
  document.querySelectorAll('[data-cart-form] input[type=number]').forEach(function(i){
    i.addEventListener('change',function(){ i.form.submit(); });
  });
})();
